import React, { useState } from 'react';
import { useLocation } from 'react-router-dom';
import { Tag, X } from 'lucide-react';

const HIDDEN_PATHS = ['/dashboard'];

const PromoBanner = () => {
  const { pathname } = useLocation();
  const [showTerms, setShowTerms] = useState(false);

  // Hide on advertiser dashboard and all admin pages
  if (HIDDEN_PATHS.includes(pathname) || pathname.startsWith('/admin')) {
    return null;
  }

  return (
    <>
      <section
        className="bg-navy text-cream border-b-4 border-gold"
        data-testid="testimonial-promo-banner"
      >
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-3 flex flex-col sm:flex-row items-center justify-center gap-2 sm:gap-4 text-center">
          <span className="inline-flex items-center gap-2 bg-gold text-navy px-3 py-1 rounded-full text-xs font-bold uppercase tracking-wide whitespace-nowrap">
            <Tag size={14} />
            Testimonial Promo
          </span>
          <p className="text-sm md:text-base">
            <span className="font-bold">20% off</span> a 3-month Partial Wrap campaign with testimonial —
            <span className="font-semibold"> only 3 spots left</span>.
            <button
              type="button"
              onClick={() => setShowTerms(true)}
              className="block sm:inline text-cream/60 text-xs sm:ml-2 underline hover:text-gold transition-colors"
              data-testid="testimonial-view-terms"
            >
              Testimonial terms apply.
            </button>
          </p>
        </div>
      </section>

      {showTerms && (
        <div
          className="fixed inset-0 z-50 flex items-center justify-center bg-navy/70 backdrop-blur-sm p-4"
          onClick={() => setShowTerms(false)}
          data-testid="testimonial-terms-modal"
        >
          <div
            className="bg-cream-light rounded-2xl shadow-2xl max-w-md w-full p-6 relative"
            onClick={(e) => e.stopPropagation()}
          >
            <button
              type="button"
              onClick={() => setShowTerms(false)}
              className="absolute top-3 right-3 text-navy/60 hover:text-navy transition-colors"
              aria-label="Close terms"
              data-testid="testimonial-terms-close"
            >
              <X size={22} />
            </button>
            <div className="flex items-center gap-2 mb-4">
              <span className="inline-flex items-center gap-2 bg-gold text-navy px-3 py-1 rounded-full text-xs font-bold uppercase tracking-wide">
                <Tag size={14} />
                Testimonial Promo
              </span>
            </div>
            <h2 className="text-2xl font-bold text-navy mb-4">Testimonial Terms</h2>
            <ul className="space-y-3 text-navy/80 list-disc list-inside">
              <li>A verbal testimonial must be given halfway through the campaign.</li>
              <li>Advectigroup must be included in the wrap design.</li>
            </ul>
            <button
              type="button"
              onClick={() => setShowTerms(false)}
              className="mt-6 w-full bg-navy text-cream py-3 rounded-full font-semibold hover:bg-navy-dark transition-colors"
            >
              Got it
            </button>
          </div>
        </div>
      )}
    </>
  );
};

export default PromoBanner;
